import { render } from "./TestToastPage.vue?vue&type=template&id=48167c3a"
import script from "./TestToastPage.vue?vue&type=script&lang=js"
export * from "./TestToastPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__